import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "w-full remove-all-input-styling"
};
import LlSelect from '@/components/LlSelect.vue';
import { useAccountsStore } from '@/services/UserService/useAccountsStore';
import { ref, watch, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
export default {
  __name: 'TimekeeperPicker',
  props: {
    form: {
      type: Object,
      required: false
    },
    label: {
      type: String,
      default: 'Timekeeper'
    },
    labelClass: {
      type: String,
      default: 'text-sm'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: ['accountChanged'],
  setup(__props, {
    emit: __emit
  }) {
    const accountsStore = useAccountsStore();
    const {
      accountsList
    } = storeToRefs(accountsStore);
    const emit = __emit;
    const props = __props;

    // Local state to avoid mutating props directly
    // Check if account is a valid object with meaningful data (has non-empty id)
    const isValidAccount = account => {
      if (!account || typeof account !== 'object') return false;
      const {
        id
      } = account;
      return id != null && id !== '';
    };
    const initialAccount = isValidAccount(props.form.account) ? props.form.account : null;
    const localAccount = ref(initialAccount);
    watch(() => props.form.account, newVal => {
      // Check if the new value is a valid account object
      if (isValidAccount(newVal) && newVal !== localAccount.value) {
        localAccount.value = newVal;
      } else if (!isValidAccount(newVal)) {
        // If it's not valid (null, empty object, or missing id), set to null
        localAccount.value = null;
      }
    });
    const handleUpdateAccountChange = account => {
      localAccount.value = account;
      emit('update:form', {
        ...props.form,
        account
      });
    };

    // Ensure accounts data is loaded
    onMounted(async () => {
      try {
        // Load accounts list if not already loaded
        if (!accountsList.value || accountsList.value.length === 0) {
          await accountsStore.listAccounts();
        }
      } catch (error) {
        console.error('Error loading accounts:', error);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(LlSelect, {
        modelValue: localAccount.value,
        "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => localAccount.value = $event), handleUpdateAccountChange],
        items: _unref(accountsList),
        "item-title": "name",
        "item-value": "id",
        density: "compact",
        class: "at-choose-client remove-outline",
        "return-object": "",
        placeholder: `Select ${__props.label}`,
        variant: "outlined",
        "hide-details": __props.hideDetails,
        rules: __props.rules,
        label: __props.label,
        disabled: __props.disabled,
        labelClass: __props.labelClass,
        isAutocomplete: "",
        isRequired: __props.required,
        clearable: __props.clearable,
        "data-cy": "timekeeper-picker"
      }, null, 8, ["modelValue", "items", "placeholder", "hide-details", "rules", "label", "disabled", "labelClass", "isRequired", "clearable"])]);
    };
  }
};